<template>
  <div class="tts">   
    <div class="left" v-loading="paramsLoading" :element-loading-text="paramsLoading ? '加载参数中…' : ''">     
      <div class="title"><i class="el-icon-headset"></i> 请选择语音合成模型</div>  
      <div class="container">
        <div class="nav">
          <div
            v-for="(choosestyle, index) in choosestyles"
            :key="index"
            @click="clickitem(index)"
            class="item"
            :class="normal[index]"
          >
            <i class="iconfont icon-record-sound"></i
            ><span>{{ choosestyle }}</span
            ><span>{{
              datas.filter((data) => {
                return data.scene == choosestyle;
              }).length
            }}</span>
          </div>
        </div>
        <div class="contents">
          <div class="content" :class="normal[0]">
            <Speechmodel
              v-for="data in filterdata"
              :key="data.id"
              :id="data.id"
              img="./assets/female.png"
              :mycheck="data.checked"
              :name="data.name"
              :type="data.type"
              @Choosethis="clickspeecher"
            />
          </div>
        </div>
      </div>
      <div class="title parameter"><i class="el-icon-s-operation"></i> 基础参数</div>
      <div class="prametersetting">
        <div class="item">
          <span class="item1 item3"><i class="el-icon-sort"></i> 语速</span>
          <el-slider
            class="slider"
            v-model="voicevalue.speech_rate"
            :max="500"
            :min="-500"
            :show-input="true"
          ></el-slider>
          <span class="item2">正常（范围：-500 ~ 500）</span>
        </div>
        <div class="item">
          <span class="item1 item3"><i class="el-icon-mic"></i> 语调</span>
          <el-slider
            class="slider"
            v-model="voicevalue.pitch_rate"
            :max="500"
            :min="-500"
            :show-input="true"
          ></el-slider>
          <span class="item2">正常（范围：-500 ~ 500）</span>
        </div>
        <div class="item">
          <span class="item1 item3"><i class="el-icon-phone-outline"></i> 音量</span>
          <el-slider class="slider" :show-input="true" v-model="voicevalue.volume">
         </el-slider>
          <span class="item2">正常（范围：1 ~ 100）</span>
        </div>
        <div class="item">
          <span class="item1"><i class="el-icon-pie-chart"></i> 采样率</span>
          <el-radio-group v-model="voicevalue.sampleRateValue">
            <el-radio-button label="48000"></el-radio-button>
            <el-radio-button label="24000"></el-radio-button>
            <el-radio-button label="16000"></el-radio-button>
            <el-radio-button label="8000"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="item">
          <span class="item1"><i class="el-icon-document"></i> 格式</span>
          <el-radio-group v-model="voicevalue.formatValue">
            <el-radio-button label="mp3"></el-radio-button>
            <el-radio-button label="wav"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title title-input">请输入文字</div>
      <div class="txtcontent">
        <!-- 上边的文本输入框 -->
        <textarea class="wenben" v-model="voicevalue.textValue" placeholder="请输入内容"></textarea>
        <p>还可以输入<span>{{wenzilenght}}</span>字，超出部分合成将被截断</p>
        <!-- 合成语音文件的按钮和下载音频的按钮 -->
        <div class="button" v-loading="loading">
          <div class="btn btn-animate" @click="MakeVocie">
            <i class="iconfont icon-shengyinkai"></i>
            <p>点击“扬声器按钮”开始播放</p>
          </div>

          <div class="btn btn-animate" @click="goDownload">
            <i class="iconfont icon-xiazai"></i>
            <p>点击“下载按钮”下载音频到本地</p>
          </div>

          <el-dialog center :before-close="function(){}" :show-close="false" :destroy-on-close="true" :visible.sync="dialogTableVisible" width="680px">
            <pay :img="qrimg" :money="money" paytype="alipay"></pay>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="paystatus" plain >已完成支付</el-button>
              <el-button type="info" @click="paystatus" plain >支付遇到问题</el-button>
            </span>
          </el-dialog>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Speechmodel from "./speechmodel.vue";
import pay from './pay.vue'
export default {
  name: "DBTTS",
  data() {
    return {
      orderid:'',
      money:0.66,
      loading:false,
      paramsLoading:false,
      qrimg:"",
      dialogTableVisible:false,
      datapath:"",
      voicevalue: {
        voice:"xiaoyun",
        speech_rate: 0,
        pitch_rate: 0,
        volume: 50,
        sampleRateValue: "24000",
        formatValue: "mp3",
        textValue: "",
      },
      normal: ["active", "", "", "", ""],
      currentIndex: 0,
      choosestyles: ["通用", "多情感", "客服", "超高清", "直播", "童声"],
      choosestyle: "通用",
      datas: []
    };
  },
  components: {
    Speechmodel,
    pay,
  },
  mounted(){
    this.paramsLoading = true
    this.$axios.get("/getttsdata").then(response => {
      this.datas = response.data || []
    }).catch(() => {
      this.$message({ message: '参数加载失败，请检查网络连接或稍后重试', type: 'error', duration: 5000 })
    }).finally(() => {
      this.paramsLoading = false
    })
  },
  methods: {
    paystatus(){
        this.dialogTableVisible=false
        this.$axios.post('/queryOrder',{out_trade_no:this.orderid}).then(res=>{
          if(res.data=='交易完成')this.DownFile();
        })
    },
    goDownload() {
      if (!this.$store.state.user) {
        this.$message.warning('请先登录后再下载');
        this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' });
        return;
      }
      this.alipay();
    },
    alipay(){
      if(this.voicevalue.textValue==null || this.voicevalue.textValue.length==0)
      {
        this.$message({
          message: '请输入内容',
          type: 'warning'
        });
        return;
      }
      this.loading=true;
      let data={
        money:this.money,
        subject:"语音合成"
      }
      this.$axios.post('/qrpayment',data)
      .then(res=>{
        //window.location.href=res.data.result;
        this.qrimg=res.data.filename
        this.dialogTableVisible=true
        this.loading=false;
        this.orderid=res.data.out_trade_no       
      })
    },
    DownFile(){
      if(this.datapath==null || this.datapath.length==0)
      {
        this.$message({
          message: '请生成音频后再下载',
          type: 'warning'
        });
        return;
      }
      fetch(this.datapath)
      .then(res => res.blob())
      .then(blob => {
        const a = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        a.download = new Date().getTime()+"." +this.voicevalue.formatValue;
        a.href = objectUrl;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        a.remove();
      })
    },
    MakeVocie() {
      if (!this.voicevalue.textValue || !this.voicevalue.textValue.trim()) {
        this.$message.warning('请输入要合成的内容');
        return;
      }
      this.loading = true;
      this.$axios.post("/tts", this.voicevalue).then((response) => {
        var audio = document.createElement("audio");
        this.datapath = this.$store.state.basicurl + response.data;
        audio.src = this.datapath;
        audio.play();
      }).catch((err) => {
        this.$message.error(err.response && err.response.data ? (err.response.data.message || '合成失败') : '合成失败，请重试');
      }).finally(() => {
        this.loading = false;
      });
    },
    clickspeecher(id) {
      for (var i = 0; i < this.datas.length; i++) {
        if (id != this.datas[i].id) {
          this.datas[i].checked = false;
        } else {
          this.datas[i].checked = !this.datas[i].checked;
          if(this.datas[i].checked)
          this.voicevalue.voice=this.datas[i].voice
        }
      }
    },
    filtercount(choosestyle) {
      this.datas.filter((data) => {
        return data.style == choosestyle;
      }).length;
    },
    clickitem(type) {
      this.currentIndex = type;
      for (var i = 0; i < this.normal.length; i++) {
        this.normal.splice(i, 1, "");
      }
      this.$set(this.normal, type, "active");
      this.choosestyle = this.choosestyles[type];
    },
    handleClick(tab, event) {
      this.choosestyle = tab.label;
      console.log(tab.label, event);
    },
  },
  computed: {
    
    filterdata() {
      return this.datas.filter((data) => {
        return data.scene == this.choosestyle;
      });
    },
    wenzilenght(){
        return 300-this.voicevalue.textValue.length;
    },   
  },
};
</script>

<style scoped>
    @media(min-width: 769px){
        .mydialog{
          width:680px;
        }
        .tts {
          display: flex;
        }
        .left {
          flex-grow: 2;
        }
        .right {
          flex-grow: 1;
          margin-left: 15px;
        }
        .right .title {
          min-height: 40px;
          margin-bottom: 0;
        }
        .title {
          margin-bottom: 10px;
          margin-left: 15px;
          display: flex;
          align-items: center;
        }
        .title i {
          margin-right: 6px;
          vertical-align: middle;
          color: #409EFF;
          font-size: 18px;
        }
        .container {
          border: 1px solid #dedede;
          display: flex;
          align-items: stretch;
        }
        .nav {
          /* display:flex;
                flex-direction: column; */
          width: 180px;
        }
        .nav .item {
          padding-left: 15px;
          height: 55px;
          border-right: 1px solid #dedede;
          border-bottom: 1px solid #dedede;
          display: flex;
          align-items: center;
          cursor: pointer;
          background-color: #f4f4f4;
          font-size: 14px;
        }
        .nav .item span {
          margin-left: 8px;
        }

        .iconfont {
          font-size: 20px;
        }

        .nav .item.active {
          background-color: #eef7ff;
          color: #409eff;
        }
        .contents {
          width: 100%;
          overflow: auto;
          position: relative;
        }
        .content {
          position: absolute;
          padding-left: 10px;
          padding-top: 10px;
          transition: opacity 0.3;
          display: flex;
          flex-wrap: wrap;
        }
        .content span {
          font-size: 90px;
          font-weight: bold;
          color: #409eff40;
        }
        .content.active {
          opacity: 1;
        }

        .parameter {
          margin-top: 10px;
        }
        .prametersetting {
          border: 1px solid #dedede;
          padding: 14px 16px 12px;
        }

        .prametersetting .item {
          height: 50px;
          line-height: 50px;
        }
        .prametersetting .item .item1 {
          float: left;
          width: 82px;
          text-align: right;
          margin-right: 15px;
        }
        .prametersetting .item .item1 i {
          margin-right: 6px;
          color: #409EFF;
          vertical-align: middle;
        }
        .prametersetting .item .slider {
          margin-top: 5px;
          float: left;
          width: 525px;
        }
        .prametersetting .item .item2 {
          margin-left: 12px;
        }

        .txtcontent {    
          border: #dedede 1px solid;
        }

        .txtcontent .wenben {
          margin:12px auto;
          display: block;
          width: 300px;
          height: 300px;
          font-size: 14px;
          outline: none;
          border: none;
          resize: none;
          transition: box-shadow 0.2s ease;
        }
        .txtcontent:focus-within {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
        .txtcontent>p span{
            color: #FF6A00;
            font-size: 10px;
        }
        .txtcontent>p {
          line-height: 45px;
          font-size: 15px;
          padding-left:12px;
        }

        .txtcontent .button {
          border-top: 1px solid #dedede;
          height: 275px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .button .btn {
          width: 100px;
          height: 140px;
          text-align: center;
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .button .btn.btn-animate:hover {
          transform: scale(1.05);
        }
        .button .btn.btn-animate:active {
          transform: scale(0.96);
        }

        .button .btn p {
          margin-top: 30px;
          line-height: 20px;
          font-size: 12px;
          color: #111;
        }

        .button .btn .iconfont {
          border: #409eff 2px solid;
          color: #409eff;
          font-size: 45px;
          border-radius: 50%;
          padding: 15px;
          cursor: pointer;
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .button .btn .iconfont:hover {
          background-color: #409eff;
          color: #fff;
        }
    }

    @media(max-width: 768px){
        .mydialog{
          width:100vw;
        }
        .tts {
          width: 100vw;
        }
        
       
        .title {
          margin-top: 1vh;
          margin-bottom: 1vh;
          margin-left: 2vw;
          display: flex;
          align-items: center;
        }
        .right .title {
          margin-bottom: 0;
        }
        .title i {
          margin-right: 6px;
          vertical-align: middle;
          color: #409EFF;
          font-size: 18px;
        }
        .container {
          border: 1px solid #dedede;         
          width: 94vw;
          margin:0 auto;
          display: flex;
          align-items: stretch;
        }
        .nav {
          display:flex;
          flex-direction: column;
          width: 34vw;
        }
        .nav .item {
          padding-left: 1vw;
          height: 6vh;
          border-right: 1px solid #dedede;
          border-bottom: 1px solid #dedede;
          display: flex;
          align-items: center;
          cursor: pointer;
          background-color: #f4f4f4;
          font-size: 14px;
        }
        .nav .item span {
          margin-left: 1vw;
        }

        .iconfont {
          font-size: 20px;
        }

        .nav .item.active {
          background-color: #eef7ff;
          color: #409eff;
        }
        .contents {
          width: 100%;
          overflow: auto;
          position: relative;
        }
        .content {
          position: absolute;
          padding-left: 10px;
          padding-top: 10px;
          transition: opacity 0.3;
          display: flex;
          flex-wrap: wrap;
        }
        .content span {
          font-size: 90px;
          font-weight: bold;
          color: #409eff40;
        }
        .content.active {
          opacity: 1;
        }

        .parameter {
          margin-top: 10px;
        }
        .prametersetting {
          border: 1px solid #dedede;
          padding: 1vw;
          width:94vw;
          margin: 0 auto;
        }

        .prametersetting .item {
          height: 8vh;
        }
        .prametersetting .item .item1.item3{
          display: block;
        }
        .prametersetting .item .item1{
         margin-right: 4vw;
        }
        .prametersetting .item .item2 {
          display:none
        }

        .txtcontent {    
          border: #dedede 1px solid;
          width:94vw;
          margin: 0 auto;
        }

        .txtcontent .wenben {
          margin:2vw auto;
          display: block;
          width: 90vw;
          height: 20vh;
          font-size: 14px;
          outline: none;
          border: none;
          resize: none;
          transition: box-shadow 0.2s ease;
        }
        .txtcontent:focus-within {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
        .txtcontent>p span{
            color: #FF6A00;
            font-size: 10px;
        }
        .txtcontent>p {
          line-height: 45px;
          font-size: 15px;
          padding-left:12px;
        }

        .txtcontent .button {
          border-top: 1px solid #dedede;
          height:26vh;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .button .btn {
          width: 30vw;
          height: 15vh;
          text-align: center;
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .button .btn.btn-animate:hover {
          transform: scale(1.05);
        }
        .button .btn.btn-animate:active {
          transform: scale(0.96);
        }

        .button .btn p {
          margin-top: 4vh;
          line-height: 2vh;
          font-size: 12px;
          color: #111;
        }

        .button .btn .iconfont {
          border: #409eff 2px solid;
          color: #409eff;
          font-size: 45px;
          border-radius: 50%;
          padding: 5vw;
          cursor: pointer;
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .button .btn .iconfont:hover {
          background-color: #409eff;
          color: #fff;
        }
    }
    

/* div span{
    padding-top:20px;
    padding-bottom:20px;
    position: absolute;
    top:0;
    bottom: 0;
    margin-top:auto;
    margin-bottom: auto;
} */
</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.dark-mode .tts {
    .title { color: var(--text-primary); }
    .container { border-color: var(--border-color); }
    .contents {
        overflow: auto !important;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
    }
    .nav .item {
        background-color: var(--bg-secondary);
        border-color: var(--border-color);
        color: var(--text-regular);
    }
    .nav .item.active { background-color: var(--hover-bg); color: #409eff; }
    .parameter { color: var(--text-primary); }
    .prametersetting {
        border-color: var(--border-color);
        background: var(--bg-card);
        .item .item1 { color: var(--text-regular); }
        .item .item1 i { color: #409eff; }
        .item .item2 { color: var(--text-secondary); }
    }
    .txtcontent {
        border-color: var(--border-color);
        background: var(--bg-card);
        .wenben {
            background: var(--input-bg);
            color: var(--text-primary);
        }
        > p { color: var(--text-regular); }
        .button { border-top-color: var(--border-color); }
        .button .btn p { color: var(--text-regular); }
    }
}
</style>